import { render, staticRenderFns } from "./afterSaleTreatment.vue?vue&type=template&id=19c7304c&scoped=true&"
import script from "./afterSaleTreatment.vue?vue&type=script&lang=js&"
export * from "./afterSaleTreatment.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleTreatment.vue?vue&type=style&index=0&id=19c7304c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7304c",
  null
  
)

export default component.exports